module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_realestate-4ef6263d69c1eb9fa9486290127a3036.svg";